
export enum InvPaymentChrgToCd {
	BOTH_COLLECT = 'Both Collect',
	BOTH_PREPAID = 'Both Prepaid',
	COLLECT = 'Collect',
	PREPAID = 'Prepaid'}

